<template>
  <div>
    <router-link
      v-if="item.routeName"
      :to="generateRoute(item.routeName)"
      @click.native="saveActiveIndex(item.index)"
    >
      <el-menu-item
        :class="[
          cssClass,
          $route.name === 'ProjectOverview' &&
          item.routeName === 'ProjectOverview'
            ? 'activeItemDashboard'
            : ((item.subRouteName && item.subRouteName.includes($route.name)) ||
                item.routeName === $route.name) &&
              item.index !== '1'
            ? 'activeItem'
            : ''
        ]"
        :index="item.index"
      >
        <icon v-if="icon" :glyph="item.icon" size="20" />
        <span slot="title"
          >{{ $t(item.sectionName) }}
          <span v-if="isNew" class="new-item">{{
            $t('TaskHistoryList_Status_New')
          }}</span></span
        >
      </el-menu-item>
    </router-link>
    <a v-else :href="item.url()">
      <el-menu-item :class="cssClass" :index="item.index">
        <icon v-if="icon" :glyph="item.icon" size="20" />
        <span slot="title">{{ $t(item.sectionName) }}</span>
      </el-menu-item>
    </a>
  </div>
</template>
<script>
export default {
  name: 'LeftNavigationItem',

  props: {
    item: {
      type: Object,
      required: true
    },
    icon: {
      type: Boolean,
      required: false
    },
    cssClass: {
      type: String,
      required: true
    },
    isNew: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      activeItem: ''
    }
  },

  methods: {
    isActiveItem(item) {
      if (item.subRouteName && item.subRouteName.includes(this.$route.name)) {
        return true
      } else if (item.routeName === this.$route.name) {
        return true
      } else {
        return false
      }
    },

    generateRoute(routeName) {
      return {
        // @TODO: Remove after Campaign create release
        name: typeof routeName === 'function' ? routeName() : routeName,
        query: { project_id: this.$store.getters.projectId }
      }
    },

    saveActiveIndex(index) {
      window.sessionStorage.setItem(
        this.$store.getters.projectId + '-active-nav-item',
        index
      )
    },

    setActiveItem() {
      this.activeItem = window.sessionStorage.getItem(
        this.$store.getters.projectId + '-active-nav-item'
      )
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        this.setActiveItem()
      }
    }
  }
}
</script>
<style scoped>
.dashboard-item {
  color: #ffffff;
  height: 64px;
  line-height: 62px;
}

.dashboard-item span {
  margin-left: 20px;
}

.dashboard-item.activeItem {
  background-color: #115178;
}

.activeItem {
  background-color: #176ca0;
}

.level2 >>> .el-submenu__title {
  height: 48px;
  line-height: 46px;
}

.level2 span {
  padding-left: 45px;
}

.level2 .level3 {
  height: 32px;
  line-height: 30px;
  background-color: #115178;
  user-select: none;
}

.level2 .level3:hover {
  background-color: #1d87c8;
}

.level3 {
  font-size: 12px;
}

.nav-menu-popup-ct .level3 span {
  padding-left: 45px;
}

.level3 span {
  padding-left: 25px;
}
.new-item {
  background: #f9dc75;
  border-radius: 3px;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 1;
  color: #6f5701;
  padding: 2px 3px;
  margin-left: 12px;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/common/components/navigation/LeftNavigationItem.vue